import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/f3f31709-7f58-4a83-97e0-5687afb32de1";
export const REGISTER_URL = "https://a.ntrk2.com/39417dad-aa9f-4ee0-a45b-79d44fdd6c38";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://adda7.kzw2a.com/download?openExternalBrowser=1&id=oaspzhxf8znqfaz";

export * from "./codes";
export * from "./context";
